import { OgpApiService } from './ogp-api-service';
import { WorkApplicationTableItem } from '../../shared/services/work-application-service.types';

export class WorkApplicationService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  workApplicationsForProject = async (projectId: string) => {
    const response = await this.ogpApiService.get<WorkApplicationTableItem[]>({
      path: `work-applications/project/${projectId}`,
    });
    return response;
  };

  denyWorkApplication = async (workApplicationId: string, workerId: string) => {
    await this.ogpApiService.update<void>({
      path: `work-applications/deny/${workApplicationId}`,
      body: { workerId },
    });
  };

  acceptWorkApplication = async (workApplicationId: string) => {
    await this.ogpApiService.update<void>({
      path: `work-applications/accept/${workApplicationId}`,
    });
  };
}
